<template>
  <el-dialog :visible.sync="visible" :title="'修改'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-table v-loading="dataListLoading" :data="form.dataBoardList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="boardType" label="学生评价维度" header-align="center" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.boardType === 0" size="small" type="success">点赞曝光</p>
            <p v-if="scope.row.boardType === 1" size="small" type="success">班级评价趋势</p>
            <p v-if="scope.row.boardType === 2" size="small" type="success">班级评价维度</p>
            <p v-if="scope.row.boardType === 3" size="small" type="success">学生出勤</p>
            <p v-if="scope.row.boardType === 4" size="small" type="success">学生评价趋势</p>
            <p v-if="scope.row.boardType === 5" size="small" type="success">学生评价维度</p>
            <p v-if="scope.row.boardType === 6" size="small" type="success">点赞曝光</p>
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="是否显示" header-align="center" align="center">
          <template slot-scope="scope">
          <el-radio-group  v-model="scope.row.isShow">
            <el-radio :label="0" >否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
          </template>
        </el-table-column>
                <el-table-column prop="weight" label="排序"  align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.weight"
                              @keyup.enter.native="updateThisSort(scope.row,index,scope.$index)">
                    </el-input>
                  </template>
                </el-table-column>
              </el-table>

            </el-form>
            <template slot="footer">
              <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
              <el-button type="primary" @click="updateThisSort()">{{ $t('confirm') }}</el-button>
            </template>
          </el-dialog>
        </template>

        <script>
          import {moralismScreen} from '../../../constant';
          import debounce from 'lodash/debounce'
        export default {
          data () {
            return {
              visible: false,
              dataForm: {
                id: '',
                boardType: '',
                isShow: '',
                schoolId: '',
                creator: '',
                updater: '',
                createDate: '',
                updateDate: '',
              },
              form: {
                dataBoardList:[]
              }

            }
          },
          computed: {
            dataRule () {
              return {
              }
            }
          },
          methods: {
            init () {
              console.log('-----------------')
              console.log(this.form.dataBoardList)
              this.visible = true
              this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm.id) {
                  this.getInfo()
                }
              })
            },
            updateThisSort () {
              console.log('=====')
              const  params={
                dataBoardList:  this.form.dataBoardList
              }
              console.log(this.form.dataBoardList)
              this.boardDataListLoading= true
              this.$http.post('MoralismScreenBoardRule/moralismscreenboardrule/updateAll',params).then(({ data: res }) => {
                this.boardDataListLoading = false
                this.visible = false
                if (res.code !== 0) {
                  return this.$message.error(res.msg)
                }
                this.$message({
                  message: this.$t('prompt.success'),
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              }).catch(() => {
              })

            },
            // 获取信息
            getInfo () {
              this.$http.get('/MoralismScreenBoardRule/moralismscreenboardrule/' + this.dataForm.id).then(({ data: res }) => {
                if (res.code !== 0) {
                  return this.$message.error(res.msg)
                }
                this.dataForm = {
                  ...this.dataForm,
                  ...res.data
                }
              }).catch(() => {})

            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                this.$http[!this.dataForm.id ? 'post' : 'put']('/MoralismScreenBoardRule/moralismscreenboardrule/', this.dataForm).then(({ data: res }) => {
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                }).catch(() => {})
              })
            }, 1000, { 'leading': true, 'trailing': false })
          }
        }
        </script>
